export const GET_QUESTIONNAIRE_QUERY_KEY = 'questionnaire';
export const GET_BENEFITS_QUERY_KEY = 'benefits';
export const PUT_SURVEY_RESPONSES_QUERY_KEY = 'submit_questionnaire';
export const QUESTIONNAIRE_BENEFIT_CATEGORY = 'survey';
export const CONFIGURATION_ERROR_CODE = 'configuration';
